import { useState, useEffect, useRef } from 'react';
import '../../../entrydoor.css';

// SillFinish — options depend on SillType:
//   Standard → Clear Anodized, Black Anodized
//   Handicap → Mill
const STANDARD_OPTIONS = [
  { value: 'ClearAnodized', label: 'Clear Anodized' },
  { value: 'BlackAnodized', label: 'Black Anodized' },
];

const HANDICAP_OPTIONS = [
  { value: 'Mill', label: 'Mill' },
];

const SillFinish = ({ value = { value: '', label: '' }, onChange, disabled = false, sillType }) => {
  const [selected, setSelected] = useState(value?.value || '');
  const skipValueSync = useRef(false);

  const options = sillType?.value === 'Standard' ? STANDARD_OPTIONS
                : sillType?.value === 'Handicap' ? HANDICAP_OPTIONS
                : [];

  // Sync from parent (load from DB)
  useEffect(() => {
    if (skipValueSync.current) { skipValueSync.current = false; return; }
    setSelected(value?.value || '');
  }, [value?.value]);

  // When sillType changes, clear if current selection is no longer valid
  useEffect(() => {
    if (selected && !options.find(o => o.value === selected)) {
      skipValueSync.current = true;
      setSelected('');
      onChange({ value: '', label: '' });
    }
  }, [sillType?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = options.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdSillFinish">Sill Finish</label>
      <select id="SdSillFinish" value={selected} onChange={handleChange} disabled={disabled}>
        {options.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SillFinish;
